import { API_BASE_URL } from "../config/apiBaseUrl";

const ADMIN_BASE = "/api/admin/automotive";
const PORTAL_BASE = "/api/v1/automap/dealer-portal";

function authHeaders() {
  return { credentials: "include", headers: { "Content-Type": "application/json" } };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") search.set(k, v);
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchTrialsDashboard(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/trials/dashboard${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar trials.");
  return res.json();
}

export async function fetchAdminDealerTrials(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/trials${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar trials.");
  return res.json();
}

export async function fetchDealerTrialDetail(dealerId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/trial`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar trial.");
  return res.json();
}

export async function postTrialDecision(dealerId, action, body = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/trial/decision`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify({ action, ...body }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Acción fallida.");
  }
  return res.json();
}

export async function createTrialFollowUp(dealerId, payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/trial/follow-ups`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo crear follow-up.");
  return res.json();
}

export async function completeTrialFollowUp(followUpId, payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/trial/follow-ups/${encodeURIComponent(followUpId)}`, {
    method: "PATCH",
    ...authHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo completar follow-up.");
  return res.json();
}

export async function addTrialConversation(dealerId, payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/trial/conversations`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo agregar conversación.");
  return res.json();
}

export async function fetchDealerTrialPanel(dealerId) {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/trial-panel`,
    authHeaders()
  );
  if (!res.ok) return null;
  return res.json();
}
